module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG469a7ccfe6af7daa095a79d9be106075.469a7ccf.png";